(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_af6be15"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('phenyx-focus-reviews')) return;

  class PhenyxFocusReviews extends HTMLElement {
    connectedCallback() {
      this.bootFrame = requestAnimationFrame(() => {
        if (this.isConnected && !this.initialized) this.initialize();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.bootFrame);
      this.stopAutoplay();
      this.stopAnimation();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.listeners?.forEach(removeListener => removeListener());
      this.querySelectorAll('[data-focus-clone]').forEach(element => element.remove());
      this.initialized = false;
      this.pointer = null;
      this.removeAttribute('data-ready');
      this.removeAttribute('data-dragging');
    }

    numberSetting(key, fallback, minimum, maximum) {
      const value = Number(this.dataset[key]);
      return Math.max(minimum, Math.min(maximum, Number.isFinite(value) && this.dataset[key] !== '' ? value : fallback));
    }

    initialize() {
      this.stage = this.querySelector('[data-focus-stage]');
      this.initialized = true;
      if (!this.stage) return;
      this.querySelectorAll('[data-focus-clone]').forEach(element => element.remove());
      this.sources = [...this.stage.querySelectorAll('[data-review-source]')];
      this.count = this.sources.length;
      if (!this.count) return;
      this.config = {
        autoplay: this.dataset.autoplay === 'true',
        loop: this.dataset.loop !== 'false' && this.count > 1,
        interval: this.numberSetting('speed', 4000, 2000, 8000),
        duration: this.numberSetting('duration', 550, 200, 900),
        direction: this.dataset.direction === 'prev' ? -1 : 1,
        columns: Math.round(this.numberSetting('columns', 3, 1, 4)),
        gap: this.numberSetting('gap', 20, 8, 40),
        mobileGap: this.numberSetting('mobileGap', 10, 8, 24),
        mobileWidth: this.numberSetting('mobileWidth', 89, 78, 94) / 100,
        sideRatio: this.numberSetting('sideRatio', 62, 55, 85) / 100,
        sideOpacity: this.numberSetting('sideOpacity', 90, 55, 100) / 100,
        maxWidth: this.numberSetting('maxCardWidth', 680, 360, 760),
        compact: this.dataset.compact !== 'false',
        compactSectionWidth: this.numberSetting('compactSectionWidth', 1300, 1000, 1600),
        compactCardWidth: this.numberSetting('compactCardWidth', 560, 400, 640),
        compactFont: this.numberSetting('compactFont', 22, 18, 26),
        compactMinHeight: this.numberSetting('compactMinHeight', 200, 160, 300),
        mainPadding: this.numberSetting('focusPadding', 28, 16, 40),
        sidePadding: this.numberSetting('sidePadding', 20, 12, 40),
        focusFont: this.numberSetting('focusFont', 28, 18, 32),
        mobileFont: this.numberSetting('mobileFont', 18, 15, 22),
        pauseHover: this.dataset.pauseHover !== 'false',
        threshold: this.numberSetting('dragThreshold', 18, 8, 40)
      };
      this.position = 0;
      this.destination = 0;
      this.frame = null;
      this.timer = null;
      this.pointer = null;
      this.geometry = null;
      this.lastWidth = 0;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.visible = true;
      this.suppressClickUntil = 0;
      this.listeners = [];
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.config.autoplay && !this.motionQuery.matches;
      this.previous = this.querySelector('[data-focus-prev]');
      this.next = this.querySelector('[data-focus-next]');
      this.toggle = this.querySelector('[data-focus-toggle]');
      this.toggleLabel = this.querySelector('[data-focus-toggle-label]');
      this.positionLabel = this.querySelector('[data-focus-position]');
      this.progress = this.querySelector('[data-focus-progress]');
      this.announcement = this.querySelector('[data-focus-announcement]');
      this.measureElement = this.querySelector('[data-focus-measure]');
      this.hint = this.querySelector('[data-focus-hint]');
      const copies = this.config.loop ? 3 : 1;
      const pool = [];
      for (let copyIndex = 0; copyIndex < copies; copyIndex += 1) {
        this.sources.forEach((source, reviewIndex) => {
          const element = copyIndex === 0 ? source : source.cloneNode(true);
          if (copyIndex > 0) {
            element.removeAttribute('data-review-source');
            element.setAttribute('data-focus-clone', '');
            this.stage.appendChild(element);
          }
          pool.push({
            element,
            index: reviewIndex,
            poolIndex: copyIndex * this.count + reviewIndex,
            hasProduct: element.dataset.hasProduct === 'true',
            quote: element.querySelector('[data-review-quote]'),
            mainStars: element.querySelector('.pp-focus-main-stars'),
            sidePerson: element.querySelector('.pp-focus-side-person'),
            mainPerson: element.querySelector('.pp-focus-main-person'),
            image: element.querySelector('.pp-focus-product-image'),
            linkText: element.querySelector('.pp-focus-link-text')
          });
        });
      }
      this.views = pool;
      this.setAttribute('data-compact', String(this.config.compact));
      this.style.setProperty('--pp-compact-width', `${this.config.compactSectionWidth}px`);
      this.setAttribute('data-ready', 'true');
      this.setAttribute('data-single', String(this.count < 2));
      this.bindEvents();
      this.measure(true);
      this.updateControls();
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.stage);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.scheduleAutoplay();
      }, { threshold: .08 });
      this.intersectionObserver.observe(this.stage);
      document.fonts?.ready.then(() => {
        if (this.isConnected && this.initialized) this.measure(true);
      });
      this.scheduleAutoplay();
    }

    listen(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      this.listeners.push(() => target.removeEventListener(eventName, handler, options));
    }

    modulo(value, period = this.count) {
      return ((value % period) + period) % period;
    }

    measure(force = false) {
      const width = this.stage.clientWidth;
      if (!width || (width === this.lastWidth && force !== true)) return;
      this.lastWidth = width;
      const mobile = width < 750;
      const compact = this.config.compact;
      const maxCardWidth = compact ? Math.min(this.config.maxWidth, this.config.compactCardWidth) : this.config.maxWidth;
      let columns = Math.min(this.count, this.config.columns);
      const gap = mobile ? this.config.mobileGap : this.config.gap;
      if (!mobile) {
        while (columns > 1 && Math.min(maxCardWidth, (width - (columns - 1) * gap) / (1 + (columns - 1) * this.config.sideRatio)) * this.config.sideRatio < 220) columns -= 1;
      }
      const mainPadding = Math.min(this.config.mainPadding, mobile ? 22 : compact ? 24 : 40);
      const sidePadding = Math.min(this.config.sidePadding, mobile || compact ? 18 : 28);
      const mainWidth = mobile ? width * this.config.mobileWidth : Math.min(maxCardWidth, (width - (columns - 1) * gap) / (1 + (columns - 1) * this.config.sideRatio));
      const sideWidth = mainWidth * this.config.sideRatio;
      const before = mobile ? 0 : Math.floor((columns - 1) / 2);
      const after = mobile ? Math.min(1, this.count - 1) : columns - before - 1;
      const groupWidth = mainWidth + (columns - 1) * (sideWidth + gap);
      const origin = mobile ? (this.count > 1 ? 8 + mainWidth / 2 : width / 2) : (width - groupWidth) / 2 + before * (sideWidth + gap) + mainWidth / 2;
      const maximumFont = compact ? Math.min(this.config.focusFont, this.config.compactFont) : this.config.focusFont;
      const mainFont = mobile ? Math.min(this.config.mobileFont, maximumFont) : Math.min(maximumFont, Math.max(18, width * .021));
      const sideFont = mobile ? 14 : Math.min(18, Math.max(14, mainFont * .64));
      const quoteTop = compact ? 60 : mobile ? 74 : 86;
      const sideQuoteTop = compact ? 76 : 106;
      const withProductReserve = compact ? 164 : 198;
      const withoutProductReserve = compact ? 76 : 98;
      this.measureElement.style.width = `${Math.max(60, mainWidth - mainPadding * 2)}px`;
      this.measureElement.style.fontSize = `${mainFont}px`;
      let requiredHeight = 0;
      this.sources.forEach(source => {
        this.measureElement.innerHTML = source.querySelector('[data-review-quote]').innerHTML;
        const reserve = source.dataset.hasProduct === 'true' ? withProductReserve : withoutProductReserve;
        requiredHeight = Math.max(requiredHeight, quoteTop + this.measureElement.getBoundingClientRect().height + reserve + 4);
      });
      const minimumHeight = compact ? this.config.compactMinHeight : mobile ? 446 : Math.max(430, Math.min(560, width * .34));
      const mainHeight = Math.ceil(Math.max(minimumHeight, requiredHeight));
      this.geometry = {
        width, mobile, compact, before, after, gap, origin, mainWidth, sideWidth, mainHeight,
        sideHeight: mainHeight * (compact ? .88 : .84), mainPadding, sidePadding, mainFont, sideFont,
        quoteTop, sideQuoteTop, withProductReserve, withoutProductReserve,
        step: (mainWidth + sideWidth) / 2 + gap
      };
      this.setAttribute('data-mobile', String(mobile));
      this.stage.style.height = `${mainHeight + (compact ? 28 : 42)}px`;
      this.render();
    }

    render() {
      if (!this.geometry) return;
      const layout = this.geometry;
      const period = this.views.length;
      const basePosition = this.config.loop ? this.count + this.position : this.position;
      this.views.forEach(view => {
        const relative = this.config.loop ? this.modulo(view.poolIndex - basePosition + period / 2, period) - period / 2 : view.index - this.position;
        const distance = Math.abs(relative);
        const lower = -layout.before - .75;
        const upper = layout.after + .75;
        const visible = relative > lower && relative < upper;
        const interactive = visible && relative > -layout.before - .35 && relative < layout.after + .35;
        view.element.hidden = !visible;
        view.element.inert = !interactive;
        view.element.setAttribute('aria-hidden', String(!interactive));
        view.element.classList.toggle('is-current', distance < .001);
        if (!visible) return;
        const focus = Math.max(0, 1 - distance);
        const width = layout.sideWidth + (layout.mainWidth - layout.sideWidth) * focus;
        const height = layout.sideHeight + (layout.mainHeight - layout.sideHeight) * focus;
        const offset = Math.sign(relative) * (distance <= 1 ? distance * layout.step : layout.step + (distance - 1) * (layout.sideWidth + layout.gap));
        const padding = layout.sidePadding + (layout.mainPadding - layout.sidePadding) * focus;
        const edgeOpacity = Math.max(0, Math.min(1, (relative - lower) / .3, (upper - relative) / .3));
        view.element.style.width = `${width}px`;
        view.element.style.height = `${height}px`;
        view.element.style.transform = `translate3d(${layout.origin + offset - width / 2}px, ${(layout.mainHeight - height) / 2}px, 0)`;
        view.element.style.zIndex = String(10 + Math.round(focus * 10));
        view.element.style.opacity = String((this.config.sideOpacity + (1 - this.config.sideOpacity) * focus) * edgeOpacity);
        view.element.style.setProperty('--pp-view-padding', `${padding}px`);
        view.element.style.borderColor = focus > .65 ? 'var(--pp-focus-border)' : 'var(--pp-border)';
        const quoteTop = layout.sideQuoteTop + (layout.quoteTop - layout.sideQuoteTop) * focus;
        const activeReserve = view.hasProduct ? layout.withProductReserve : layout.withoutProductReserve;
        const sideReserve = view.hasProduct ? layout.compact ? 100 : 126 : layout.compact ? 20 : 26;
        const reserve = sideReserve + (activeReserve - sideReserve) * focus;
        view.quote.style.top = `${quoteTop}px`;
        view.quote.style.maxHeight = `${Math.max(0, height - quoteTop - reserve)}px`;
        view.quote.style.fontSize = `${layout.sideFont + (layout.mainFont - layout.sideFont) * focus}px`;
        view.quote.style.color = focus > .5 ? 'var(--pp-focus-text)' : 'var(--pp-text-color)';
        const mainOpacity = Math.max(0, Math.min(1, (focus - .6) / .4));
        view.mainStars.style.opacity = String(mainOpacity);
        view.mainPerson.style.opacity = String(mainOpacity);
        view.sidePerson.style.opacity = String(Math.max(0, Math.min(1, (.4 - focus) / .4)));
        if (view.image) {
          const imageSize = layout.compact ? (layout.mobile ? 40 : 44) + focus * 10 : (layout.mobile ? 44 : 58) + focus * 14;
          view.image.style.width = `${imageSize}px`;
          view.image.style.height = view.image.style.width;
        }
        if (view.linkText) view.linkText.hidden = width < 430;
      });
    }

    stopAnimation() {
      if (this.frame !== null && this.frame !== undefined) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    stopAutoplay() {
      clearTimeout(this.timer);
      this.timer = null;
    }

    scheduleAutoplay() {
      this.stopAutoplay();
      if (!this.initialized || !this.isConnected || !this.playing || this.count < 2 || this.motionQuery.matches || this.pointer || this.focused || this.editorSelected || !this.visible || document.hidden || (this.config.pauseHover && this.hovered)) return;
      this.timer = setTimeout(() => {
        const nextTarget = Math.round(this.destination) + this.config.direction;
        if (!this.config.loop && (nextTarget < 0 || nextTarget >= this.count)) {
          this.playing = false;
          this.updateControls();
          return;
        }
        this.move(this.config.direction, false);
      }, this.config.interval);
    }

    updateControls(manual = false) {
      const index = this.config.loop ? this.modulo(Math.round(this.destination)) : Math.max(0, Math.min(this.count - 1, Math.round(this.destination)));
      this.previous.disabled = this.count < 2 || (!this.config.loop && index === 0);
      this.next.disabled = this.count < 2 || (!this.config.loop && index === this.count - 1);
      this.positionLabel.textContent = `${String(index + 1).padStart(2, '0')} / ${this.count}`;
      this.progress.style.width = `${(index + 1) / this.count * 100}%`;
      if (this.toggle) {
        this.toggle.hidden = !this.config.autoplay || this.count < 2;
        this.toggle.disabled = this.motionQuery.matches;
        this.toggle.setAttribute('aria-pressed', String(this.playing));
        this.toggle.setAttribute('aria-label', this.playing ? 'Pause automatic reviews' : 'Play automatic reviews');
        this.toggleLabel.textContent = this.playing ? 'Pause' : 'Play';
      }
      if (this.hint) {
        this.hint.hidden = this.count < 2;
        this.hint.textContent = this.motionQuery.matches ? 'Use the arrows to explore' : 'Drag to explore';
      }
      if (manual) this.announcement.textContent = `Review ${index + 1} of ${this.count}: ${this.sources[index].getAttribute('aria-label')}`;
    }

    animateTo(target, manual = true) {
      if (!this.config.loop) target = Math.max(0, Math.min(this.count - 1, target));
      this.stopAnimation();
      this.stopAutoplay();
      const start = this.position;
      const started = performance.now();
      this.destination = target;
      this.updateControls(manual);
      const duration = this.motionQuery.matches || Math.abs(target - start) < .001 ? 0 : this.config.duration;
      const tick = timestamp => {
        if (!this.initialized || !this.isConnected) return;
        const fraction = duration ? Math.min(1, (timestamp - started) / duration) : 1;
        this.position = start + (target - start) * (1 - Math.pow(1 - fraction, 4));
        this.render();
        if (fraction < 1) this.frame = requestAnimationFrame(tick);
        else {
          this.position = this.config.loop ? this.modulo(target) : target;
          this.destination = this.position;
          this.frame = null;
          this.render();
          this.updateControls();
          this.scheduleAutoplay();
        }
      };
      this.frame = requestAnimationFrame(tick);
    }

    move(direction, manual = true) {
      if (this.count < 2) return;
      this.animateTo(Math.round(this.destination) + direction, manual);
    }

    finishPointer(event) {
      if (!this.pointer || (event && event.pointerId !== this.pointer.id)) return;
      const released = this.pointer;
      this.pointer = null;
      this.removeAttribute('data-dragging');
      if (this.stage.hasPointerCapture(released.id)) this.stage.releasePointerCapture(released.id);
      if (released.moved) {
        this.suppressClickUntil = performance.now() + 400;
        const difference = released.lastX - released.startX;
        const meaningful = Math.abs(difference) > this.config.threshold || Math.abs(released.velocity) > .28;
        const steps = event?.type === 'pointercancel' || !meaningful ? 0 : -Math.sign(difference) * Math.max(1, Math.min(3, Math.round(Math.abs(difference) / this.geometry.step)));
        this.animateTo(Math.round(released.origin) + steps);
      } else this.animateTo(Math.round(this.position), false);
    }

    bindEvents() {
      this.listen(this.previous, 'click', () => this.move(-1));
      this.listen(this.next, 'click', () => this.move(1));
      if (this.toggle) this.listen(this.toggle, 'click', () => {
        this.playing = !this.playing && !this.motionQuery.matches;
        this.updateControls();
        this.scheduleAutoplay();
      });
      this.listen(this.stage, 'pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        if (this.config.pauseHover) this.stopAutoplay();
      });
      this.listen(this.stage, 'pointerleave', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = false;
        if (this.pointer && !this.pointer.moved) this.finishPointer();
        this.scheduleAutoplay();
      });
      this.listen(this.stage, 'focusin', () => { this.focused = true; this.stopAutoplay(); });
      this.listen(this.stage, 'focusout', event => {
        if (!this.stage.contains(event.relatedTarget)) { this.focused = false; this.scheduleAutoplay(); }
      });
      this.listen(this.stage, 'pointerdown', event => {
        if (this.count < 2 || !event.isPrimary || event.button !== 0 || !this.geometry) return;
        this.stopAnimation();
        this.stopAutoplay();
        this.pointer = { id: event.pointerId, startX: event.clientX, startY: event.clientY, lastX: event.clientX, lastTime: performance.now(), velocity: 0, origin: this.position, moved: false };
      });
      this.listen(this.stage, 'pointermove', event => {
        if (!this.pointer || event.pointerId !== this.pointer.id) return;
        const differenceX = event.clientX - this.pointer.startX;
        const differenceY = event.clientY - this.pointer.startY;
        if (!this.pointer.moved && Math.abs(differenceY) > Math.abs(differenceX) * 1.15 && Math.abs(differenceY) > 8) {
          this.pointer = null;
          this.animateTo(Math.round(this.position), false);
          return;
        }
        if (!this.pointer.moved && Math.abs(differenceX) > 6 && Math.abs(differenceX) > Math.abs(differenceY)) {
          this.pointer.moved = true;
          this.setAttribute('data-dragging', 'true');
          this.stage.setPointerCapture(event.pointerId);
        }
        if (!this.pointer.moved) return;
        event.preventDefault();
        const now = performance.now();
        this.pointer.velocity = (event.clientX - this.pointer.lastX) / Math.max(1, now - this.pointer.lastTime);
        this.pointer.lastTime = now;
        this.pointer.lastX = event.clientX;
        const desired = this.pointer.origin - differenceX / this.geometry.step;
        this.position = this.config.loop ? desired : Math.max(-.15, Math.min(this.count - 1 + .15, desired));
        this.destination = this.position;
        this.render();
      });
      ['pointerup', 'pointercancel'].forEach(eventName => this.listen(window, eventName, event => this.finishPointer(event)));
      this.listen(this.stage, 'lostpointercapture', event => this.finishPointer(event));
      this.listen(this.stage, 'click', event => {
        if (performance.now() < this.suppressClickUntil) { event.preventDefault(); event.stopPropagation(); return; }
        if (event.target.closest('a')) return;
        const card = event.target.closest('.pp-focus-card');
        if (!card || !this.geometry) return;
        const view = this.views.find(candidate => candidate.element === card);
        if (!view) return;
        const period = this.views.length;
        const relative = this.config.loop ? this.modulo(view.poolIndex - (this.count + this.position) + period / 2, period) - period / 2 : view.index - this.position;
        if (Math.abs(relative) > .45) this.animateTo(Math.round(this.position + relative));
      }, true);
      this.listen(this.stage, 'dragstart', event => event.preventDefault());
      this.listen(this, 'keydown', event => {
        if (event.target.closest('input,select,textarea') || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          if (this.stage.contains(event.target)) (direction > 0 ? this.next : this.previous).focus({ preventScroll: true });
          this.move(direction);
        }
      });
      this.listen(document, 'visibilitychange', () => this.scheduleAutoplay());
      this.listen(this.motionQuery, 'change', () => {
        if (this.motionQuery.matches) {
          this.playing = false;
          this.stopAnimation();
          this.position = this.config.loop ? this.modulo(Math.round(this.destination)) : Math.round(this.destination);
          this.destination = this.position;
          this.render();
        }
        this.updateControls();
        this.scheduleAutoplay();
      });
      this.listen(document, 'shopify:block:select', event => {
        if (String(event.detail?.blockId) === this.dataset.blockId) { this.editorSelected = true; this.stopAutoplay(); }
      });
      this.listen(document, 'shopify:block:deselect', event => {
        if (String(event.detail?.blockId) === this.dataset.blockId) { this.editorSelected = false; this.scheduleAutoplay(); }
      });
    }
  }

  customElements.define('phenyx-focus-reviews', PhenyxFocusReviews);
})();
  } catch(e) { console.error(e); }
})();

})();
